import $http from "./http";
import config from "./config";

export default {
  name: "train",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  CheckRepeatOrder(data) {
    return $http.post(this.getUrl("/TrainOrder/CheckRepeatOrder"), data, {
      failTips: false,
    });
  },
  CreateOrder(data) {
    return $http.post(this.getUrl(`/TrainOrder/CreateOrder`), data);
  },
  OrderDetails(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/OrderDetails?UniqueID=${UniqueID}`));
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/OrderSubmit/${UniqueID}`));
  },
  // CreateReceiveRequest(data) {
  //     return $http.post(this.getUrl('/TrainOrder/CreateReceiveRequest'), data);
  // },
  // TradeSubmit(id) {
  //     return $http.get(this.getUrl(`/TrainOrder/SubmitReceiveRequest?TradeID=${id}`));
  // },
  OrderCannot(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderCannot?UniqueID=${id}`));
  },
  OrderDrawer(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderDrawer?UniqueID=${id}`));
  },
  OrderReject(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderReject?UniqueID=${id}`));
  },
  OrderResolve(data) {
    return $http.post(this.getUrl(`/TrainOrder/OrderResolve`), data);
  },
  ClientOrderResolve(data) {
    return $http.post(this.getUrl("/TrainOrder/ClientOrderResolve"), data);
  },
  UpdateGoods(goods) {
    return $http.post(this.getUrl("/TrainOrder/UpdateGoods"), goods);
  },
  CreateAmend(amend) {
    return $http.post(this.getUrl(`/TrainOrder/CreateAmend`), amend);
  },
  //下单价格计算
  // getTrainOrder(data) {
  //     return $http.post(this.getUrl(`/TrainOrder/TrainOrder`), data);
  // },

  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  MessageSend(data) {
    return $http.post(this.getUrl("/TrainOrder/MessageSend"), data);
  },
  // ChangeOrderDetail(data) {
  //     return $http.post(this.getUrl('/TrainOrder/ChangeOrderDetail'), data);
  // },

  UpdateOrder(data) {
    return $http.post(this.getUrl("/TrainOrder/UpdateOrder"), data);
  },
  CalcPrice(price, date) {
    return $http.get(this.getUrl(`/TrainFixInAdvance/CalcPrice?price=${price}&date=${date}`));
  },
  TrainOrderChange(data) {
    return $http.post(this.getUrl("/TrainOrder/TrainOrderChange"), data);
  },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderCancel?UniqueID=${id}`), {
      failTips: false,
    });
  },
  OrderUnLock(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderUnLock?UniqueID=${id}`));
  },
  OrderLock(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderLock?UniqueID=${id}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl("/TrainOrder/OrderRefund"), data);
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderRefundCancel?UniqueID=${id}`));
  },
  ConfirmOrderPrice(data) {
    return $http.post(this.getUrl(`/TrainOrder/ConfirmOrderPrice`), data);
  },
  UpdateOrderStatus(id) {
    return $http.get(this.getUrl(`/TrainOrder/UpdateOrderStatus?UniqueID=${id}`));
  },
  UpdateOrderPrice(data) {
    return $http.post(this.getUrl("/TrainOrder/UpdateOrderPrice"), data);
  },
  AmendStatusBack(id) {
    return $http.get(this.getUrl(`/TrainOrder/AmendStatusBack?UniqueID=${id}`));
  },
  // getOrderDetail(id) {
  //     return $http.get(this.getUrl(`/TrainOrder/GetOrderDetail/${id}`));
  // },

  CreateTrade(data) {
    return $http.post(this.getUrl(`/TrainOrder/CreateTrade`), data);
  },

  ConfirmClientAmendPrice(data) {
    return $http.post(this.getUrl("/TrainOrder/ConfirmClientAmendPrice"), data);
  },

  ConfirmSupplyAmendPrice(data) {
    return $http.post(this.getUrl("/TrainOrder/ConfirmSupplyAmendPrice"), data);
  },

  getTrainLodinInfos(data) {
    return $http.post(this.getUrl(`/TrainFixInAdvance/checkOfficialAccount`), data);
  },
  getTrainInfos(data) {
    return $http.post(this.getUrl(`/TrainFixInAdvance/checkPassCard`), data);
  },
  // savetrainorder(data) {
  //     return $http.post(this.getUrl('/TrainFixInAdvance/CreateOrder'), data);
  // },
  getOrderList(data) {
    return $http.post(this.getUrl("/TrainOrder/List"), data);
  },
  // ,getTrainTicket(id){
  //     return $http.get(this.getUrl(`/TrainTickets/GetTrainTicket/${id}`));
  // },
  // getPassInfo(id){
  //     return $http.get(this.getUrl(`/TrainPass/GetPassInfo/${id}`));
  // },
  // getOrderStatus(id) {
  //     return $http.get(this.getUrl(`/TrainOrder/GetOrderStatus/${id}`));
  // },
  // getSeatFail(id) {
  //     return $http.get(this.getUrl(`/TrainFixInAdvance/SetSeatFail/${id}`));
  // },
  // getAgainSeat(id) {
  //     return $http.get(this.getUrl(`/TrainFixInAdvance/AgainSaveSeat/${id}`));
  // },
  // getCancelOrder(id) {
  //     return $http.get(this.getUrl(`/TrainFixInAdvance/OrderCancel/${id}`));
  // },
  getRefundTicket(id) {
    return $http.get(this.getUrl(`/TrainFixInAdvance/RefundTickets/${id}`));
  },
  getTrainAmend(data) {
    return $http.post(this.getUrl("/TrainFixInAdvance/TrainAmend"), data);
  },
  getDetails(id) {
    return $http.get(this.getUrl(`/TrainOrder/Details/${id}`));
  },
  // getTrainEcndorse(data) {
  //     return $http.post(this.getUrl('/TrainFixInAdvance/TrainEcndorse'), data);
  // },

  ConsumerVerification(data) {
    return $http.post(this.getUrl(`/TrainOrder/ConsumerVerification`), data, { failTips: false });
  },

  AmendList(data) {
    return $http.post(this.getUrl("/TrainAmend/List"), data);
  },

  AmendDetails(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/AmendDetails/?UniqueID=${UniqueID}`));
  },
  // AmendList(data) {
  //     return $http.post(this.getUrl('/TrainFixInAdvance/QueryRefundPrice'), data)
  // },
  // getRefundPriceDetails(id) {
  //     return $http.get(this.getUrl(`TrainFixInAdvance/RefundPriceDetails/${id}`))
  // },
  // getSubmissionSupply(data) {
  //     return $http.post(this.getUrl('/TrainFixInAdvance/SubmissionSupply'), data);
  // },
  //审核通过
  // getAuditingApproval(id) {
  //     return $http.post(this.getUrl(`TrainFixInAdvance/AuditingApproval/${id}`));
  // },
  // //拒绝退款
  // getRefusalOfRefund(id) {
  //     return $http.post(this.getUrl(`TrainFixInAdvance/RefusalOfRefund/${id}`));
  // },
  //再次提交改签
  // getAgainChanges(id) {
  //     return $http.post(this.getUrl(`TrainFixInAdvance/AgainChanges/${id}`));
  // },
  //取消改签
  // getCancelTrainChanges(id) {
  //     return $http.post(this.getUrl(`TrainFixInAdvance/CancelTrainChanges/${id}`));
  // },
  OrderPayment(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/OrderPayment/${UniqueID}`));
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/TrainOrder/SearchOrders?UniqueID=${id}`));
  },
  GetSimpleOrder(id) {
    return $http.get(this.getUrl(`/TrainOrder/GetSimpleOrder?UniqueID=${id}`));
  },
  trainaccountlogin(data){
    return $http.post(this.getUrl('/TrainAccount/AccountLogin'),data);
  },
  validaccount(data){
    return $http.post(this.getUrl('/TrainAccount/ValidAccount'), data,{ failTips: false })
  },
  resetvalid(data){
    return $http.post(this.getUrl('/trainaccount/ResetValid'),data)
  },
  resetpassword(data){
    return $http.post(this.getUrl('/trainaccount/ResetPassword'),data)
  },
  trainbooking(id){
    return $http.get(this.getUrl('/trainorder/TrainBooking?UniqueId='+id))
  },
  deleteaccount(id){
    return $http.get(this.getUrl('/trainaccount/delete?id='+id))
  },
  accountlist(){
    return $http.post(this.getUrl('/trainaccount/list'));
  },
  checkamend(id){
    return $http.get(this.getUrl('/trainorder/CheckAmend?UniqueId='+id),{ failTips: false })
  },
  validaccountById(data){
    return $http.post(this.getUrl('/trainorder/ValidAccountById'),data)
  },
  CreateAmendTradeDeal(id){
    return $http.get(this.getUrl('/trainorder/CreateAmendTradeDeal?UniqueID='+id))
  },
  SearchExtras(data) {
    return $http.post(this.getUrl('/TrainOrder/SearchExtras'), data);
  },
  CreateExtras(data) {
      return $http.post(this.getUrl('/TrainOrder/CreateExtras'), data);
  },
  SendEmail(orderId,unionId,email) {
      return $http.get(this.getUrl('/TrainOrder/SendEmail?orderId='+orderId+'&UnionId='+unionId+'&email='+email));
  },
  UpdateOrderSupplyStatus(UniqueID) {
      return $http.get(this.getUrl(`/trainorder/UpdateOrderSupplyStatus?UniqueID=${UniqueID}`));
  },
  CheckPaymentAvailable(contactPhone, contactName) {
    return $http.get(this.getUrl(`/TrainOrder/CheckPaymentAvailable?contactPhone=${contactPhone}&contactName=${contactName}`),{ failTips: false });
  },
};



// WEBPACK FOOTER //
// ./src/apis/trainApis.js